import { Box, Button, Typography } from '@mui/material'
import React from 'react'

const HeroSection = () => {
  return (
    <Box sx={{ textAlign: 'center', py: '10vh' }}>
      <Typography variant='h2'>
        Fun with GPT-3
      </Typography>
      <Typography variant='body2'>
        GPT-3 is OpenAI&apos;s AI model which can respond to prompts sent by the client.
      </Typography>
      <Button variant='text' href='https://beta.openai.com/overview' sx={{ textDecoration: 'underline' }}>
        Learn more about GPT-3
      </Button>
    </Box>
  )
}

export default HeroSection